import type { GuideStats } from '@nolens/domain';
import { useLocale } from '@nolens/ui';
import { componentsText } from '../i18n/components';

/** Leituras dos últimos 30 dias: total e uma barra por dia (membros, ligação pública, embed). */
export function StatsStrip({ stats }: { stats: GuideStats }) {
  const t = componentsText(useLocale());
  const days = stats.last30;
  const sum = (d: GuideStats['last30'][number]) => d.member + d.public + d.embed;
  const last30 = days.reduce((n, d) => n + sum(d), 0);
  const max = Math.max(1, ...days.map(sum));
  const by = days.reduce(
    (a, d) => ({
      member: a.member + d.member,
      public: a.public + d.public,
      embed: a.embed + d.embed,
    }),
    { member: 0, public: 0, embed: 0 },
  );
  return (
    <div className="flex items-end gap-4" data-stats={last30}>
      <div>
        <p className="text-[22px] font-semibold leading-none">{last30}</p>
        <p className="mt-1 text-[12.5px] text-text-3">{t.reads30}</p>
      </div>
      <svg width="150" height="32" viewBox="0 0 150 32" role="img" aria-label={t.readsAria(max)}>
        {days.map((d, i) => {
          const h = Math.max(sum(d) ? 3 : 1, (sum(d) / max) * 30);
          return (
            <rect
              key={d.day}
              x={i * 5}
              y={32 - h}
              width="3.5"
              height={h}
              rx="1"
              fill={sum(d) ? 'var(--accent)' : 'var(--border)'}
            />
          );
        })}
      </svg>
      <p className="text-[12.5px] leading-snug text-text-3">
        {t.readsBy(by.member, by.public, by.embed)}
        <br />
        {t.readsAll(stats.total)}
      </p>
    </div>
  );
}
